import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};

/** Subtle fade-and-rise when content first scrolls into view. Disabled for reduced motion. */
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '0px 0px -60px 0px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-278" data-mp="2jqg7zqz6mo5v">
      {children}
    </motion.div>;
}